/**
 * Login page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Platform, NavController, LoadingController, ToastController, NavParams, AlertController, ModalController } from '@ionic/angular';
import { PouchService } from '../services/pouch-service';
import { sign } from 'crypto';
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  styleUrls: ['login.scss'],
  providers: [NavParams],
  encapsulation: ViewEncapsulation.None,
})
export class LoginPage {
  navParams = {};
  databasename: string;
  username: string;
  password: string;
  isadmin: false;
  customer: any = null;
  error = '';
  ishelp = false;
  ios = false;
  ismobile = false;
  forgot = false;
  email = '';
  credentials: any;
  user;
  add = false;

  constructor(public modalCtrl: ModalController, public navParams2: NavParams, private titleService: Title, public alertCtrl: AlertController, public toastController: ToastController, public loadingCtrl: LoadingController, private platform: Platform, public nav: NavController, public http: HttpClient, public db: PouchService, private router: Router) {
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : this.navParams2.data;
    this.titleService.setTitle(`Login - ${this.db.appinfo.title}`);
    if (this.db.gsetting && this.db.gsetting.username) {
      this.add = true;
    }
    if (this.platform.is('mobile') && !this.platform.is('tablet')) {
      this.ismobile = true;
    }
    if (this.platform.is('ios')) {
      this.ios = true;
    }

    if (this.navParams != undefined && this.navParams['database'] != undefined) {
      this.databasename = this.navParams['database'];
      this.password = this.navParams['password'];
      this.login();
    }
    this.db.appinfo.setup = true; // tell db that this is an initial setup, so that it can ensure all data
  }

  async demo() {
    if (false) {
      // this.ismobile) {
      this.redirectToLaptop('view demo');
    } else {
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      let alert = await this.alertCtrl.create({
        header: this.db.rename('Lets Stay in Touch!'),
        message: `${this.db.rename('Enter your Business Name and WhatsApp number with country code to view a demo of the')} ${this.db.rename(this.db.appinfo.title)} ${this.db.rename('software')}.`,
        inputs: [
          {
            name: 'name',
            placeholder: this.db.rename('Your Business Name'),
            value: '',
          },
          {
            name: 'phone',
            placeholder: `${this.db.rename('WhatsApp Number')}: ${this.db.userinfo.country_calling_code || '+234'} XXX XXX XXXX`,
            value: '',
          },
        ],
        buttons: [
          {
            text: this.db.rename('Cancel'),
            handler: (data) => {
              this.presentToast('You can also create a free account to try the software', 'toast-warning');
            },
          },
          {
            text: this.db.rename('View Demo'),
            handler: (data) => {
              if (data.name != '' && data.phone != '' && data.phone.includes('+') && data.phone.length > 9 && data.phone.length < 16) {
                let message = `New Demo Request from ${data.name} with WhatsApp number ${data.phone} from ${this.db.userinfo.country}: https://wa.me/${data.phone.replace('+', '')}?text=${this.whatsAppMessage(data.name)}`;
                this.db.sendEmailToUser('contactsarutech@gmail.com', `${this.db.rename('Demo Request for ' + this.db.appinfo.title)}`, message);
                this.continueDemo();
                /* //send zapier message
                this.http.post('https://sarutech.com/api/app/whatsappZapier', { product: this.db.appinfo.base_product, message: `New Demo Request from ${data.name} with WhatsApp number ${data.phone} from ${this.db.userinfo.country}` }, { headers: headers }).subscribe(
                  async (res) => {
                    this.validatePhone(data.phone);
                  },
                  (err) => {
                    this.validatePhone(data.phone);
                  }
                ); */
              } else {
                if (data.name == '') {
                  this.presentToast(this.db.rename('Please enter your Business Name'), 'toast-danger');
                } else if (data.phone == '') {
                  this.presentToast(this.db.rename('Please enter a valid WhatsApp Number'), 'toast-danger');
                } else if (!data.phone.includes('+') || data.phone.length < 10 || data.phone.length > 15) {
                  this.presentToast(this.db.rename('Phone number must include country code and be between 10 and 15 digits'), 'toast-danger');
                } else {
                  this.presentToast(this.db.rename('Please enter your Business Name and a valid WhatsApp Number'), 'toast-danger');
                }
              }
            },
          },
        ],
      });
      alert.present();
    }
  }

  whatsAppMessage(name) {
    let str = `Hello ${name}, Thanks for checking out ${this.db.appinfo.title}, We are here if you have any question. https://apps.sarutech.com/${this.db.appinfo.base_product}`;
    return str.replace(/ /g, '%20');
  }

  viewPricing() {
    window.open(`https://sarutech.com/pricing/${this.db.appinfo.base_product}/${this.db.userinfo.country}`, '_blank');
  }

  async validatePhone(phone) {
    let alert = await this.alertCtrl.create({
      header: this.db.rename('Send us a verification code'),
      message: `<div class="verifywhatsapp">${this.db.rename(`Please send`)} <i>${this.db.appinfo.base_product}</i> ${this.db.rename('to')} <a href="https://api.whatsapp.com/send/?phone=447823606537" target="_blank"><img src="assets/img/whatsapp.png" /> +447823606537</a> <br/> ${this.db.rename('from your WhatsApp number')}: ${phone} ${this.db.rename('and click verify')}`,
      buttons: [
        {
          text: this.db.rename('Cancel'),
          handler: (data) => {
            this.continueDemo();
          },
        },
        {
          text: this.db.rename('Verify'),
          handler: () => {
            this.continueDemo();
          },
        },
      ],
    });
    alert.present();
    //check if number has any country code and is in the right format
    if (phone.includes('+') && phone.length > 9 && phone.length < 16) {
    } else {
      this.presentToast(this.db.rename('Invalid WhatsApp Number'), 'toast-danger');
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  continueDemo() {
    this.databasename = this.db.appinfo.base_product + 'test';
    if (this.isadmin) {
      this.password = this.db.appinfo.base_product + 'test';
    } else {
      this.username = 'admin';
      this.password = 'admin';
    }
    this.login();
  }

  togglehelp() {
    this.ishelp = !this.ishelp;
  }

  async login() {
    if (this.databasename == undefined || this.databasename == '') {
      this.error = this.db.rename('Please enter a valid database name');
      return;
    }
    if (this.db.appinfo.base_product == 'hospital') {
      localStorage.setItem('global', 'hospital');
    }
    let product = this.databasename.substring(0, this.databasename.indexOf('$'));
    if (product == '') {
      localStorage.removeItem(this.db.appinfo.base_product);
    } else {
      localStorage.setItem(this.db.appinfo.base_product, product);
      this.db.appinfo.product = product;
      this.db.appinfo.filtered = true;
    }
    this.databasename = this.databasename.substring(this.databasename.indexOf('$') + 1);
    this.db.gsetting.id = this.databasename;
    this.http
      .post('https://sarutech.com/api/getByIndex', {
        index: 'username',
        value: this.databasename,
      })
      .subscribe(
        async (customer: any) => {
          if (customer) {
            this.customer = customer;
            if (this.customer?.data?.databases?.[`${this.db.appinfo.product}$${this.databasename}`]?.alternative_db?.keep_default === false) {
              this.alternativeDBLogin();
            } else {
              if (this.isadmin) {
                this.adminLogin();
              } else {
                this.userLogin();
              }
            }
          }
        },
        (err) => {
          console.log(err);
          this.error = this.db.rename('Cannot find Account. Please create an account to use this software.');
        }
      );
  }

  async alternativeDBLogin() {
    let cdb = this.customer.data.databases[`${this.db.appinfo.product}$${this.databasename}`];
    this.credentials = {
      password: cdb.alternative_db.password,
      user_id: this.databasename,
      online: this.db.online,
      skip_setup: false,
    };
    this.db.gsetting = {
      id: this.customer.data.username,
      password: this.customer.data._password,
      company: this.customer.data.fullname,
      contactname: this.customer.data.fullname,
      username: this.customer.data.username,
      phone: this.customer.data.phonenumber,
      email: this.customer.data.email,
      expiredate: cdb.license.expiredate,
      startdate: cdb.license.startdate,
      plans: cdb.license.plan,
      country: this.customer.data.country,
      alternative_db: cdb.alternative_db,
      restrictions: cdb.license.restrictions,
      signature: cdb.license.signature,
    };
    //init replication status
    this.db.replications_pending = 0;
    this.db.replications_total = 1;
    this.db.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.db.loading.present();
    this.db.initDB(this.credentials, false, false).then(async (res) => {
      this.db.loading.dismiss();
      this.db.credentials = this.credentials;
      this.router.navigateByUrl('/LoginUserPage', { state: { admin: true, start: true } });
      //this.goHome(this.password);
    });
  }

  async userLogin() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    let data = {
      database: this.databasename.split('$')[1] == undefined ? this.db.appinfo.product + '$' + this.databasename : this.databasename,
      username: this.username,
      password: this.password,
    };
    this.http.post(`${this.db.server_url}/app/userdblogin`, data, { headers: headers }).subscribe(
      async (res: any) => {
        this.user = { ...res.user.doc, ...res.user.doc.data };
        await this.adminLogin(res.password);
      },
      (err) => {
        this.error = this.db.rename('Cannot find licensed user account. You require a license to use this software on more than one device. Please contact us for more information.');
      }
    );
  }

  async adminLogin(password = this.password) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');

    let user = {
      username: this.databasename,
      password: password,
    };
    this.db.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.db.loading.present();
    if (this.db.online) {
      this.http.post('https://sarutech.com/couchdblogin/auth/login', user, { headers: headers }).subscribe(
        async (res) => {
          if (res['userDBs'][this.db.appinfo.product] != undefined) {
            this.credentials = res;
            //ensure transaction is in https
            //let remote = this.credentials.userDBs[this.db.appinfo.product];
            //if (remote.substr(0, 5) != 'https') {
            //remote = remote.substring(0, 4) + "s" + remote.substring(4, remote.length);
            //this.credentials.userDBs[this.db.appinfo.product] = remote;
            //}
            //continue
            this.credentials.password = password;
            this.credentials.online = this.db.online;
            this.credentials.skip_setup = false;

            //init replication status
            this.db.replications_pending = 0;
            this.db.replications_total = 1;
            this.db.initDB(this.credentials, false).then(async (res) => {
              await this.db.loadDefaultDb(this.credentials);
              this.goHome(password);
            });
          } else {
            this.error = this.db.rename('This database is not for this Software. Please login to a valid database');
            await this.db.loading.dismiss();
            this.db.loading = await this.loadingCtrl.create({
              message: `${this.db.rename('Please wait')}...`,
            });
          }
        },
        (err) => {
          if (err.status == '401') {
            this.db.gsetting = {
              id: this.customer.data.username,
              password: this.customer.data._password,
              company: this.customer.data.fullname,
              contactname: this.customer.data.fullname,
              username: this.customer.data.username,
              phone: this.customer.data.phonenumber,
              email: this.customer.data.email,
              expire_date: this.customer.data.expire_date,
              plans: JSON.parse(this.customer.data.plans),
              country: this.customer.data.country,
            };
            let message = `Welcome back ${this.customer.data.fullname}, You cannot use this software on more than one device without a license. Please Purchase a license.`;
            this.router.navigateByUrl('/AddPaymentPage', { state: { message: message, create: true } });
          } else if (err.status == '404') {
            this.error = this.db.rename('Server Error') + this.db.rename('Cannot find licensed user account. You require a license to use this software on more than one device. Please contact us for more information.');
            let data: any = {
              subject: 'Database Details ',
              message: `${err.message} error, database ${this.databasename} having issue logging in ${this.db.online ? 'online' : 'offline'} to the ${this.db.appinfo.title}`,
              to: 'admin@sarutech.com',
              from: 'team@sarutech.com',
              company: 'SARU TECH',
            };

            let headers = new HttpHeaders();
            headers.append('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Origin', '*');
            this.http.post('https://sarutech.com/api/app/pos_email', JSON.stringify(data));
          }
          // this.error = err.status;
          this.offlineLogin(password);
        }
      );
    } else {
      console.log('offline');
      this.offlineLogin(password);
    }
    //await this.db.loading.dismiss();
  }

  goHome(password) {
    this.db.get(this.credentials.user_id, 'setting').then((setting) => {
      if (setting != undefined) {
        setting.password = password;
        if (setting.showtip == undefined || setting.pos_email != undefined) {
          if (setting.showtip == undefined) {
            setting.pos_print = true;
            setting.logo = '';
            setting.expire_alert_days = 30;
            setting.showtip = true;
          }
          if (setting.pos_email != undefined) {
            delete setting.pos_email;
          }
          this.db.update(setting, 'setting');
        }
        this.db.gsetting = setting;
      }
    });
    console.log('timeout');
    var mythis = this;
    window.setTimeout(async function () {
      if (mythis.db.gsetting.username == undefined) {
        // fetch remote settings
        await mythis.http
          .post('https://sarutech.com/api/app/get', { id: `setting_2_${mythis.databasename}`, database: `${mythis.db.appinfo.product}$${mythis.databasename}` })
          .toPromise()
          .then((res: any) => {
            if (res.data) {
              mythis.db.gsetting = res.data;
            }
          });
      }
      mythis.db.loading.dismiss();
      if (mythis.add) {
        window.location.reload();
      } else if (mythis.isadmin || mythis.user == undefined) {
        mythis.router.navigateByUrl('/LoginUserPage', { state: { admin: true, start: true } });
      } else {
        localStorage.setItem(mythis.db.appinfo.product + '_user', JSON.stringify(mythis.user));
        //initialize variables
        mythis.db.user = mythis.user;
        mythis.router.navigateByUrl('/PreloadPage', {
          replaceUrl: true,
        });
      }
    }, 10000);
  }

  offlineLogin(password) {
    this.credentials = {
      user_id: this.databasename,
      password: password,
      online: false,
      skip_setup: true,
    };

    this.db.databaseExist(this.db.appinfo.product + '$' + this.credentials.user_id).then(async (exist) => {
      if (exist) {
        this.db.initDB(this.credentials, false).then((msg) => {
          this.goHome(password);
        });
      } else {
        console.log('failed');
        //this.error = "Database not Found! Please check your database name and password or create a new account";
        await this.db.loading.dismiss();
        this.db.loading = await this.loadingCtrl.create({
          message: `${this.db.rename('Please wait')}...`,
        });
      }
    });
  }

  async redirectToLaptop(action = 'sign up') {
    // open an alert form to email the url to the user
    let alert = await this.alertCtrl.create({
      header: `${this.db.rename(`We recommend using a computer to ${action}`)}`,
      message: `${this.db.rename(`Go to this link on your laptop or desktop computer or Enter your email address and we will send you the link`)}: <br/> <a href="#">https://apps.sarutech.com/${this.db.appinfo.base_product}</a> <br /> <br /> <b><i>${this.db.rename(`You can then use your mobile devices to access the app after you purchase a license`)}.</i></b>`,
      inputs: [
        {
          name: 'email',
          placeholder: `${this.db.rename(`Email`)}`,
        },
      ],
      buttons: [
        {
          text: `${this.db.rename(`Cancel`)}`,
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: `${this.db.rename(`Send`)}`,
          handler: (data) => {
            if (data.email == undefined || data.email == '') {
              this.presentToast(this.db.rename('Please enter a valid email address'), 'toast-danger');
              return;
            } else {
              let subject = `${this.db.rename('Link to ' + action + ' for ' + this.db.appinfo.title)}`;
              let message = `${this.db.rename(`Click the link below to ${action} for ${this.db.appinfo.title}`)}: https://apps.sarutech.com/${this.db.appinfo.base_product}`;
              // send email
              this.db.sendEmailToUser(data.email, subject, message);
              // send zapier message to whatsapp to notify admin
              let _data = {
                product: this.db.appinfo.base_product,
                message: `User ${data.email} is being emailed a ${action} link to ${this.db.appinfo.title}`,
              };
              this.http.post('https://sarutech.com/api/app/whatsappZapier', _data).subscribe();
            }
          },
        },
      ],
    });
    alert.present();
  }

  async launchSignup() {
    if (this.ismobile) {
      this.redirectToLaptop();
    } else {
      this.router.navigateByUrl('/SignupPage');
    }
  }

  emailpassword() {
    this.forgot = false;
    let request = {
      type: 'finduser',
      email: this.email,
    };
    this.http.post('https://sarutech.com/api/app/rest', JSON.stringify(request)).subscribe((res) => {
      let database = res['msg'];
      if (database == 'Cannot find customer') {
        this.error = this.db.rename('Email not Found');
      } else {
        let message = `${this.db.rename('Hi')} ${database.fullname} <br/> ${this.db.rename('Here is your database details')}: `;
        message += `<p><strong>${this.db.rename('Database')}</strong> : ${database.username}</p>`;
        message += `<p><strong>${this.db.rename('Password')}</strong> : ${database.password}</p>`;
        message += `<p><strong>${this.db.rename('Product')}</strong> : ${database.product}}</p>`;
        let data: any = {
          subject: 'Database Details ',
          message: message,
          to: database.email,
          from: 'team@sarutech.com',
          company: 'SARU TECH',
        };

        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        this.http.post('https://sarutech.com/api/app/pos_email', JSON.stringify(data)).subscribe((res) => {
          this.error = this.db.rename('Database details sent to your email');
        });
      }
    });
  }

  account() {
    this.router.navigateByUrl('/ForgotPasswordPage');
  }

  cancel() {
    this.modalCtrl.dismiss();
  }
}
